<template>
    <img
        alt=""
        :width="width"
        :height="height"
        v-lazy="{ src: parseImageUrl(url, width, height)}"
        v-if="url && isLazy"
    />
    <img
        alt=""
        :width="width"
        :height="height"
        :src="parseImageUrl(url, width, height)"
        v-if="url && !isLazy"
    />
    <img
        alt=""
        :width="width"
        :height="height"
        src="../../assets/images/placeholder.jpg"
        class="placeholder"
        v-if="!url"
    />
    <!-- <ImagePlaceholder 
        v-if="!url"
        :width="width"
        :height="height"
    >
    </ImagePlaceholder> -->
</template>

<script>
// import ImagePlaceholder from "./ImagePlaceholder.vue";

export default {
    name: "Image",
    props: {
        image: {
            type: Object,
            default: () => {},
        },

        width: {
            type: Number,
            default: 0,
        },

        height: {
            type: Number,
            default: 0,
        },

        isLazy: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        // ImagePlaceholder,
    },
    computed: {
        url() {
            if(this.image) {
                return this.image.url;
            }
            return null;
        }
    },
    methods: {
        parseImageUrl(url, width, height) {
            if(url) {
                return url.replace("{width}", width).replace("{height}", height);
            }
            return null;
        },
    }
};
</script>
